import { useState } from 'react';
import { Maximize2, Minimize2 } from 'lucide-react';
import { c, t } from '../../theme';

// Wraps a table's scrollable body with a toggle to grow past the default
// capped height -- built for tables with enough rows that the cap means
// constant scrolling inside a small box (Jesse, Nov 2026: "some of the boxes
// require a lot of scrolling... I want an option to expand so it takes up
// more real estate"). Collapses back to the same height every table already
// used, so nothing changes until someone asks for more room.
export default function ExpandableScroll({ children, collapsedHeight = 480, expandedHeight = 1400 }) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div>
      <div style={s.toggleRow}>
        <button type="button" style={s.toggleBtn} onClick={() => setExpanded((v) => !v)}>
          {expanded ? <Minimize2 size={12} /> : <Maximize2 size={12} />}
          {expanded ? 'Collapse' : 'Expand'}
        </button>
      </div>
      <div style={{ overflow: 'auto', maxHeight: expanded ? expandedHeight : collapsedHeight }}>
        {children}
      </div>
    </div>
  );
}

const s = {
  toggleRow: { display: 'flex', justifyContent: 'flex-end', marginBottom: '2px' },
  toggleBtn: {
    display: 'inline-flex', alignItems: 'center', gap: '4px', border: 'none', background: 'transparent',
    color: c.textFaint, fontSize: t.micro.fontSize, fontWeight: 600, cursor: 'pointer', padding: '2px 6px',
  },
};
